import { Navigation, Scrollbar } from 'swiper/modules';
import Swiper from 'swiper';

export default function initCardSlider() {
  Alpine.data('cardSlider', () => ({
    init() {
      const swiperEl = this.$el.querySelector('.card-swiper') as HTMLElement;
      if (swiperEl) {
        /* eslint-disable no-new */
        new Swiper(swiperEl, {
          modules: [Scrollbar, Navigation],
          slidesPerView: 'auto',
          scrollbar: {
            el: `#${this.$el.id} .card-swiper-scrollbar`,
            draggable: true,
            dragClass: 'swiper-scrollbar-drag bg-dark/20! rounded-none! cursor-grab',
          },
          navigation: {
            nextEl: `#${this.$el.id} .swiper-button-next`,
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          spaceBetween: 16,
          breakpoints: {
            787: {
              spaceBetween: 30,
            },
          },
        });
      }
    }
  }));
}
